import React from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import { Home, FileText, Plus } from "lucide-react";
import AdminDashboard from "../components/admin/AdminDashboard";
import QuoteAnalysis from "../components/admin/QuoteAnalysis";
import RateSheetManagement from "../components/admin/RateSheetManagement";

const AdminPortal: React.FC = () => {
  const location = useLocation();
  const isAnalysisPage = location.pathname.includes("/analysis/");

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Admin Header */}
      {/* <header className="bg-white shadow-sm">
        <div className="container-custom py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Link to="/admin" className="flex items-center space-x-2">
                <Home size={24} className="text-primary" />
                <span className="text-xl font-heading font-bold text-primary">
                  Admin Portal
                </span>
              </Link>
              <nav className="hidden md:flex space-x-4">
                <Link
                  to="/admin"
                  className={`font-medium transition-colors ${
                    location.pathname === "/admin"
                      ? "text-primary border-b-2 border-primary pb-1"
                      : "text-gray-600 hover:text-primary"
                  }`}
                >
                  Dashboard
                </Link>
              </nav>
            </div>
          </div>
        </div>
      </header> */}

      {/* Main Content */}
      <main className="container-custom py-8">
        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/analysis/:requestId" element={<QuoteAnalysis />} />
          <Route path="/rate-sheets" element={<RateSheetManagement />} />
        </Routes>
      </main>
    </div>
  );
};

export default AdminPortal;
